module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "custom-class": "dialog-ad-version-shield",
      "title": _vm.dialogTitle,
      "close-on-click-modal": false,
      "modal-append-to-body": false
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('div', {
          staticClass: "flex-row-center"
        }, [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.dialogVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.clickEditDone
          }
        }, [_vm._v("确定")])], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "avs-hint"
  }, [_vm._v("策略说明")]), _vm._v(" "), _c('div', {
    staticClass: "avs-hint avs-hint--desc"
  }, [_vm._v("\n    查询数据库该用户【最近2个跑步分表】的跑步记录数量，若“跑步记录≤2次”，则对该用户屏蔽广告\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "avs-switch-row"
  }, [_c('span', {
    staticClass: "avs-switch-label"
  }, [_vm._v("策略是否生效")]), _vm._v(" "), _c('el-switch', {
    on: {
      "change": _vm.onSwitchChange
    },
    model: {
      value: (_vm.enableVersionShield),
      callback: function($$v) {
        _vm.enableVersionShield = $$v
      },
      expression: "enableVersionShield"
    }
  }), _vm._v(" "), (_vm.enableVersionShield) ? _c('span', [_c('el-radio-group', {
    model: {
      value: (_vm.versionShieldMode),
      callback: function($$v) {
        _vm.versionShieldMode = $$v
      },
      expression: "versionShieldMode"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("全部版本生效")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("指定版本生效")])], 1), _vm._v(" "), (_vm.versionShieldMode) ? _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickAddVersion
    }
  }, [_vm._v("添加规则")]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (_vm.versionShieldMode && _vm.enableVersionShield) ? _c('div', {
    staticClass: "avs-version-section"
  }, [_c('div', {
    staticClass: "avs-version-list"
  }, _vm._l((_vm.versionBlock), function(item, index) {
    return _c('div', {
      key: 'ver-' + index,
      staticClass: "avs-version-item"
    }, [_c('el-form', {
      attrs: {
        "inline": true
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "手机系统"
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "请选择"
      },
      model: {
        value: (item.osType),
        callback: function($$v) {
          _vm.$set(item, "osType", $$v)
        },
        expression: "item.osType"
      }
    }, [_c('el-option', {
      attrs: {
        "label": "Android",
        "value": "0"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "iOS",
        "value": "1"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "HarmonyOS",
        "value": "2"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "版本号"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "不限制（可为空）"
      },
      model: {
        value: (item.version),
        callback: function($$v) {
          _vm.$set(item, "version", $$v)
        },
        expression: "item.version"
      }
    })], 1), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "danger",
        "icon": "delete"
      },
      on: {
        "click": function($event) {
          return _vm.clickDeleteVersion(index)
        }
      }
    })], 1)], 1)
  }), 0)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-15b924d5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/SystemConfig/SystemConfig/Components/AdVersionShield.vue
// module id = 950
// module chunks = 0